<template>
  <tr>
    <td>{{ index + 1 }}</td>
    <td>
      <p>Заявка: <strong>{{ (order.id + '').substr(-4) }}</strong>
        ({{ $AllProjects[order.site_id] && $AllProjects[order.site_id].name }}) {{ moment(order.report_date, 'HH:mm') }}
      </p>
      <p>{{ order.address }}</p>
      <table class="table table-sm drugs_table mt-1">
        <tbody>
        <tr v-for="detail in order.details">
          <td><i v-if="detail.new_drug.cool" class="icon icon-snowflake"/> {{ detail.new_drug.title }}</td>
          <td>{{ detail.qty }}</td>
          <td>{{ detail.price }}</td>
        </tr>
        </tbody>
      </table>
      <p class="reject_comment" v-if="order.status == -3">{{ order.reject_comment }}</p>
    </td>
    <td>
      <p><strong>{{ order.price }}</strong></p>
      <p>{{ salaryRates[order.extra_options.salary_rate || 0] }}</p>
    </td>
  </tr>
</template>

<script>

import moment from "moment";

export default {
  props: ['order', 'salaryRates', 'index'],
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
  },
  methods: {
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}

</script>

<style scoped>
.reject_comment {
  background-color: #f0f0f0;
  padding: 0 5px;
  margin-bottom: 2px;
}
</style>
